import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import { loadGtm } from './gtm.ts';
import reportWebVitals from './reportWebVitals.ts';

// Apply console override for production (must be imported early)
import './utils/consoleOverride.ts';

// Global error handling for third-party scripts (herb.co, jane embed, etc.)
window.addEventListener('error', (event) => {
  const errorMessage = event.message || '';
  const errorFilename = event.filename || '';

  // Suppress known third-party script errors
  if (errorMessage.includes('herb.co') ||
      errorFilename.includes('herb.co') ||
      errorMessage.includes('Unexpected token') ||
      errorMessage.includes('appendChild') ||
      errorFilename.includes('tags.herb.co') ||
      (errorMessage.includes('SyntaxError') && errorFilename.includes('jane'))) {
    event.preventDefault();
    return true;
  }
});

// Handle unhandled promise rejections from third-party scripts
window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason?.toString() || '';
  if (reason.includes('herb.co') || reason.includes('appendChild') || reason.includes('Unexpected token')) {
    event.preventDefault();
    return true;
  }
});

loadGtm(process.env.REACT_APP_GTM_ID);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  //<React.StrictMode>
    <App />
  //</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
